

































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import store from '@/store';
const { AgGridVue } = require('ag-grid-vue');

import { fetchData, MsResponseData } from './fetchData';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { split } from 'lodash';
import moment from 'moment';
import { checkboxColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  ColGroupDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    // DetalleForm,
    // TablaInfoGral,
    'ag-grid-vue': AgGridVue,
    DatePicker,
    TimePicker,
  },
})
export default class VerDetalleModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) detalleSeleccionado: any;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  requestsStart: number = 0;
  MsResponseData: MsResponseData = null;
  tipotarifa: string = '';
  inicio: any = null;
  fin: any = null;
  fechainicio: any = null;
  fechafin: any = null;
  precio: number = 0;
  e1: number = 1;
  dia: string = '';
  dias: any = [];
  dialog: boolean = false;
  confirm: boolean = false;
  mindate: any = moment().format('YYYY-MM-DD h:mm:ss a');
  clientes: any = [];
  clientesOrigen: any = [];
  clienteOrigen: any = [];
  clienteDestino: any = [];
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  btnBloquear: boolean = true;
  columnDefsVehiculo: Array<ColDef | ColGroupDef> = [];
  columnDefsClienteDestino: Array<ColDef | ColGroupDef> = [];
  gridOptions: GridOptions;
  gridOptionsClienteDestino: GridOptions;
  localeText: any = {};
  serverSide: any;
  serverSideClienteDestino: any;
  gridApi: GridApi;
  columnApi: ColumnApi;
  gridApiClienteDestino: GridApi;
  columnApiClienteDestino: ColumnApi;
  vehiculosOrigen: any = [];
  flotaDestino: any = [];
  searchVehi: string = '';
  searchCliente: string = '';

  seleccionado: number = 0;

  handleCerrar() {
    this.$emit('cerrar');
  }

  constructor() {
    super();

    this.columnDefsVehiculo = [
      {
        ...checkboxColumnDef,
      },
      {
        headerName: 'Código',
        field: 'cod_vehiculo',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Patente',
        field: 'patente_vehiculo',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
    ];
    this.columnDefsClienteDestino = [
      {
        ...checkboxColumnDef,
      },
      {
        headerName: 'id',
        field: 'id',
        sortable: true,
        resizable: true,
        minWidth: 100,
        width: 130,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        sortable: true,
        resizable: true,
        minWidth: 200,
        width: 400,
      },
    ];

    this.gridOptions = {
      rowSelection: 'single',
      pagination: true,
      paginationPageSize: 10, //Solución Paginación
      cacheBlockSize: 10, //Solución Paginación //Ordenamiento + Selección
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      // onCellClicked: this.downloadFile,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefsVehiculo,
      suppressCopyRowsToClipboard: true,
      onSelectionChanged: this.onSelectionChangedOrigen,
      //   onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      //   onDragStopped: this.onDragStoppedEvent,
      //   onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {
        medalColumn: { width: 150, columnGroupShow: 'open', filter: false },
        // fecha: {
        //   cellRenderer: this.fechaFilter,
        //   sortable: true,
        //   resizable: true,
        //   filter: false,
        // },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
    this.gridOptionsClienteDestino = {
      rowSelection: 'single',
      rowMultiSelectWithClick: false,
      pagination: true,
      paginationPageSize: 10, //Solución Paginación
      cacheBlockSize: 10, //Solución Paginación //Ordenamiento + Selección
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSideClienteDestino,
      onGridReady: this.onGridReadyClienteDestino,
      columnDefs: this.columnDefsClienteDestino,
      suppressCopyRowsToClipboard: true,
      onSelectionChanged: this.onSelectionChangedDestino,
      //   onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        medalColumn: { width: 150, columnGroupShow: 'open', filter: false },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  async sendData() {
    this.showLoading();
    var v: any = [];
    this.vehiculosOrigen.forEach((item: any) => {
      v.push(item['cod_vehiculo']);
    });
    var f: any = [];
    f = this.flotaDestino[0]['id'];
    var body = {
      clienteid: this.clienteDestino,
      flotaid: f,
      cod_vehiculos: v,
      clienteid_origen: this.clienteOrigen,
      usuarioid: store.state.userId,
    };
    fetchData(body, 'integracion_multiflota/asignarVehiculoClienteMultiflota')
      .then((response: any) => {
        // console.log('data',response.data.data)
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(response.data.resultado);
          this.handleCerrar();
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
          console.log(response.data);
        }
        //self.gridApi.sizeColumnsToFit();
      })
      .catch((error: any) => {})
      .finally(() => {
        this.hideLoading();
      });
    // this.enviaDatos(this.peajeSeleccionado, this.detalleSeleccionado);
    // this.handleCerrar();
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  handleShowPermisos(selected: number) {
    this.seleccionado = selected;
  }

  onSelectionChangedDestino() {
    this.flotaDestino = this.gridApiClienteDestino.getSelectedRows();
    // console.log('flotaDestino: ',this.flotaDestino )
    if (this.flotaDestino.length == 0 || this.flotaDestino == undefined) {
      this.btnBloquear = true;
    } else {
      this.btnBloquear = false;
    }
  }
  onSelectionChangedOrigen() {
    this.vehiculosOrigen = this.gridApi.getSelectedRows();
    // console.log('vehiculosOrigen: ',this.vehiculosOrigen )
    if (this.vehiculosOrigen.length == 0 || this.vehiculosOrigen == undefined) {
      this.btnBloquear = true;
    } else {
      this.btnBloquear = false;
    }
  }

  async buscarClienteDestino() {
    const self = this;
    this.showLoading();
    this.serverSideClienteDestino = {
      getRows(params: any): void {
        params.request.search = self.searchCliente;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        var body = Object.assign({}, params.request, {
          clienteid: self.clienteDestino,
        });
        fetchData(body, 'integracion_multiflota/flotasCliente')
          .then((response: any) => {
            if (
              response.data.MENSAJE_RESPUESTA == 'OK' &&
              response.data.data.length > 0
            ) {
              params.successCallback(response.data.data, response.data.len);
              self.autoSizeAll(false);
              self.gridApiClienteDestino.hideOverlay();
            } else {
              params.successCallback([{}], 0);
              self.gridApiClienteDestino.showNoRowsOverlay();
            }
            //self.gridApi.sizeColumnsToFit();
          })
          .catch((error: any) => {})
          .finally(() => {
            // self.startInterval();
            self.gridApiClienteDestino.setDomLayout('autoHeight');
            self.hideLoading();
          });
      },
    };
    this.gridApiClienteDestino.setServerSideDatasource(
      this.serverSideClienteDestino
    );
  }

  async buscarVehiculo() {
    const self = this;
    this.showLoading();
    this.serverSide = {
      getRows(params: any): void {
        params.request.search = self.searchVehi;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        var body = Object.assign({}, params.request, {
          id: self.clienteOrigen,
        });
        fetchData(body, 'integracion_multiflota/get_vehicles')
          .then((response: any) => {
            if (
              response.data.MENSAJE_RESPUESTA == 'OK' &&
              response.data.data.length > 0
            ) {
              params.successCallback(response.data.data, response.data.len);
              self.autoSizeAll(false);
              self.gridApi.hideOverlay();
            } else {
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
            }
            //self.gridApi.sizeColumnsToFit();
          })
          .catch((error: any) => {})
          .finally(() => {
            // self.startInterval();
            self.gridApi.setDomLayout('autoHeight');
            self.hideLoading();
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  async onGridReadyClienteDestino(params: GridReadyEvent) {
    this.gridApiClienteDestino = params.api;
    this.columnApiClienteDestino = params.columnApi;
  }

  minfecha() {
    if (this.fechainicio == null) {
      return this.mindate;
    } else {
      // console.log(moment(this.fechainicio));
      return moment(this.fechainicio);
    }
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  async continuar() {
    console.log('this.clienteDestino', this.clienteDestino);

    if (this.flotaDestino.length > 0) {
      this.btnBloquear = false;
    } else {
      this.btnBloquear = true;
    }
    this.e1 += 1;
    if (this.e1 == 2) {
      this.btnText = 'Guardar Cambios';
      return;
    }
    if ((this.btnText = 'Guardar Cambios')) {
      this.confirm = true;
      this.e1 -= 1;
      return;
    }
    document.getElementById('cardDivCI').scrollIntoView(true);
  }

  volver() {
    this.e1 -= 1;
    if (this.e1 == 1) {
      this.btnText = 'Continuar';
      this.btnClass = 'btn-continuar';
      document.getElementById('cardDivCI').scrollIntoView(true);
    }
    if (this.clienteOrigen.length > 0) {
      this.btnBloquear = false;
    } else {
      this.btnBloquear = true;
    }
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  mounted() {
    this.getClients();
    this.getClientesMultiflota();
    // this.buscaDias();
  }

  async getClients() {
    this.showLoading();
    fetchData({}, 'integracion_multiflota/get_clients')
      .then((response: any) => {
        // console.log('data',response.data.data)
        if (response.data.data.length > 0) {
          this.clientesOrigen = response.data.data;
        } else {
          this.$snotify.error('No se encontraron clientes.');
          // console.log(response.data.MENSAJE_RESPUESTA)
        }
        //self.gridApi.sizeColumnsToFit();
      })
      .catch((error: any) => {})
      .finally(() => {
        this.hideLoading();
      });
  }

  validarBtn() {
    if (this.e1 == 1 && this.vehiculosOrigen == undefined) {
      this.btnBloquear = true;
      return;
    } else {
      this.btnBloquear = false;
    }
  }

  handleSearchVehi(event: string) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  handleSearchCliente(event: string) {
    this.gridApiClienteDestino.setServerSideDatasource(
      this.serverSideClienteDestino
    );
  }

  async getClientesMultiflota() {
    this.showLoading();
    fetchData({}, 'integracion_multiflota/getClientesMultiflota')
      .then((response: any) => {
        // console.log('data',response.data.data)
        if (response.data.data.length > 0) {
          this.clientes = response.data.data;
        } else {
          this.$snotify.error('No se encontraron clientes.');
          // console.log(response.data.MENSAJE_RESPUESTA)
        }
        //self.gridApi.sizeColumnsToFit();
      })
      .catch((error: any) => {})
      .finally(() => {
        this.hideLoading();
      });
  }

  cambiarEstado(index: number, estado: number) {
    this.detalleSeleccionado[this.seleccionado][index]['estado'] = estado;
    if (estado == 2) {
      this.detalleSeleccionado[this.seleccionado][index]['css'] =
        'border:1px solid red;width: 97%; padding: 5%; display: flex; margin-bottom: 15px;';
    } else {
      this.detalleSeleccionado[this.seleccionado][index]['css'] =
        'width: 97%; padding: 5%; display: flex; margin-bottom: 15px;';
    }
  }

  agregarTarifa() {
    var tarifa = {
      // id_peaje: this.peajeSeleccionado,
      nom_tipotarifa: split(this.tipotarifa, ' ')[0],
      val_precio: this.precio.toString(),
      val_hora_inicio: this.inicio.format('h:mm:00'),
      val_hora_fin: this.fin.format('h:mm:00'),
      nom_tipodia: this.dia,
      id_categoria: this.seleccionado + 1,
      fec_inicio_vigencia: this.fechainicio.format('YYYY-MM-DD'),
      fec_fin_vigencia: this.fechafin.format('YYYY-MM-DD'),
      id_horario: 0,
      estado: '1',
    };
    this.detalleSeleccionado[this.seleccionado].push(tarifa);
    this.tipotarifa = '';
    this.precio = 0;
    this.inicio = '';
    this.fin = '';
    this.dia = '';
  }

  // async buscaDias() {
  //   this.MsResponseData = (await this.fetchDias()) || null;
  //   if (this.MsResponseData !== null) {
  //     if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
  //       if (this.MsResponseData.data.length > 0) {
  //         for (let i = 0; i < this.MsResponseData.data.length; i++) {
  //           this.dias.push(this.MsResponseData.data[i].nom_tipodia);
  //         }
  //       } else {
  //         this.$snotify.error('No se han encontrado registros.', {
  //           timeout: 3000,
  //         });
  //       }
  //     } else {
  //       this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
  //         timeout: 3000,
  //       });
  //     }
  //   }
  // }

  onDelete(index: number) {
    if (this.detalleSeleccionado[this.seleccionado][index]['estado'] == 2) {
      return "color: 'error';";
    } else {
      return;
    }
  }

  // fetchDias() {
  //   this.showLoading();
  //   return fetchDias()
  //     .catch(error => {
  //       this.$snotify.error('Error');
  //       return;
  //     })
  //     .finally(() => this.hideLoading());
  // }
}
